import styled from 'styled-components';
import { RowTable } from '../../../../func/components/Table';
import { LandInfoProprs } from '../../data';
import { useState } from 'react';
import ListContent, { ListData } from '../ListContent';

interface Props {
  landInfo: LandInfoProprs;
}

const LandInfo = ({ landInfo }: Props) => {
  const data: ListData[] = [
    {
      label: '토지면적',
      value: landInfo.area.toFixed(1),
      isArea: true,
      value_p: landInfo.pyeong.toFixed(1),
      hasToggleButton: true,
    },
    { label: '용도지역', value: landInfo.zoning_backup },
    { label: '지목', value: landInfo.category },
    { label: '이용상황', value: landInfo.usestatus },
    { label: '고저', value: landInfo.height },
    { label: '도로', value: landInfo.roadsurface },
    {
      label: '용적률',
      value: landInfo.far_rate ? `${landInfo.far_rate}%` : '-',
    },
    {
      label: '건폐율',
      value: landInfo.bcr_rate ? `${landInfo.bcr_rate}%` : '-',
    },
  ];

  return <ListContent data={data} />;
};
export default LandInfo;
